import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import AddUserPopUp from './AddUserPopUp.jsx';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import { FormGroup, Modal, DropdownButton, MenuItem } from 'react-bootstrap';
import { map } from 'lodash';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class AddVehicle extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.dropdownSelect = this.dropdownSelect.bind(this);
    this.dropdownSelectUser = this.dropdownSelectUser.bind(this);

    this.state = {
      searchMobile: false,
      leftDropDownVisible: false,
      vehicleType: 'Vehicle type',
      userType: 'User-1',
      showpopUp: false,
      showSidebar: false,
      driverUser: []
    };
    this.initialFormData = {
      name: '',
      plate_no: '',
      vehicletype_id: '',
      driver_id: ''
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      name: false,
      plate_no: false,
      vehicletype_id: false,
      driver_id: false
    };
  }

  componentWillMount() {
    if (this.props.manageuserReducer.userInfo.length == 0) {
      this.props.actions.manageuserinfo();
    }
    if (this.props.manageuserReducer.vehicleTypes.length == 0) {
      this.props.actions.getVehicleTypes();
    }
    if (this.props.manageuserReducer.driverTypes.length == 0) {
      this.props.actions.getDriverTypes();
    }
  }

  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }

  componentWillReceiveProps(nextprops) {
    if (
      this.state.driverUser.length != this.props.manageuserReducer.userInfo.length && this.state.driverUser.length != 0
    ) {
      let userLength = this.props.manageuserReducer.userInfo.length - 1;
      this.setState({ userType: this.props.manageuserReducer.userInfo[userLength].driver.name });
      this.formData['driver_id'] = this.props.manageuserReducer.userInfo[userLength].driver.id;
      this.setState({ driverUser: this.props.manageuserReducer.userInfo });
    }
    if (this.state.driverUser.length == 0) {
      this.setState({ driverUser: this.props.manageuserReducer.userInfo });
    }
  }

  toggleNotification(isVisible) {
    this.setState({ notificationVisible: isVisible });
  }

  toggleMessage(isVisible) {
    this.setState({ messageVisible: isVisible });
  }

  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar });
  }
  onFieldChange(value, name, key) {
    this.setState({ formError: false });
    this.formData[name] = value;
    this.errors[name] = value ? false : true;
  }

  onSubmit() {
    var data = null;
    let checkValue = document.getElementsByClassName('form-group');
    map(checkValue, function(value, key) {
      data += value.className;
    });
    let checkError = data.indexOf('error') !== -1 ? true : false;
    if (checkError) {
      this.props.actions.showErrorMessage('please correct the errors on this form');
    } else {
      this.props.actions.addVehicleInfo(this.formData, this.props.router);
    }
  }
  dropdownSelect(e) {
    this.setState({ vehicleType: e.name });
    this.formData['vehicletype_id'] = e.id;
  }
  dropdownSelectUser(e) {
    if (e == 'Add User') {
      this.props.actions.showPopUP();
    } else {
      this.setState({ userType: e.driver.name });
      this.formData['driver_id'] = e.driver.id;
    }
  }

  render() {
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    const { authReducer, manageuserReducer } = this.props;
    return (
      <div>
        <AddUserPopUp
          showpopupType="AddUser"
          manageVehicle={this.props.manageuserReducer}
          actions={this.props.actions}
          driverType={this.props.manageuserReducer.driverTypes}
          authReducer={authReducer}
          commonReducer={this.props.commonReducer}
        >
          {' '}
        </AddUserPopUp>
        {/*Header*/}
        <Header
          searchMobile={this.state.searchMobile}
          hideOption={() => this.setState({ searchMobile: true })}
          commonReducer={this.props.commonReducer}
          actions={this.props.actions}
          notificationCount={2}
          profileName="Derrick Frank"
          noAutoSuggestCall="true"
          notificationCallBack={this.toggleNotification}
          authReducer={this.props.authReducer}
          hCallback={() => {
            this.hclickCallBack();
          }}
          router={this.props.router}
          isNewUser={
            authData &&
              authData.isBusinessRegistered &&
              authData.isGarageProfileCompleted &&
              authData.isGarageServiceSelected
              ? false
              : true
          }
        />
        <div className="main-wrapper">

          <Sidebar
            showSidebar={this.state.showSidebar}
            router={this.props.router}
            actions={this.props.actions}
            commonReducer={this.props.commonReducer}
            authReducer={this.props.authReducer}
          />
          {/*message*/}
          {/*<Extra message="Your email account has been verified. We are open for service!" />*/}

          <div className="container-fluid main-container">
            <div className="page-sec-header col">
              <div className="overview-heading headrer-left-pod">
                <h5 className="add-vehicle-txt">Add Vehicle</h5>
              </div>
              <div className="my-account-body">
                <div className="password-form-info password-form-wrapper">
                  <TextInput
                    type="text"
                    label="Vehicle Name"
                    name="name"
                    showValidationError={this.errors['name']}
                    validationError="Please enter your name"
                    onBlur={this.onFieldChange.bind(this)}
                  />
                  <TextInput
                    type="text"
                    label="Vehicle Plate Number"
                    name="plate_no"
                    validationError="Please enter Vehicle Plate Number"
                    showValidationError={this.errors['plate_no']}
                    onBlur={this.onFieldChange.bind(this)}
                  />
                  <div className="modal-cus-Dd veh-modal-cus-Dd-mob">
                    <DropdownButton
                      bsSize="xsmall"
                      className="selectDropDown modal-dd-text"
                      id="dropdown-size-large modal-dd-text"
                      onToggle={e => this.setState({ leftDropDownVisible: e })}
                      onSelect={e => {
                        this.dropdownSelect(e);
                      }}
                      title={
                        <div className="input-group">
                          <span className="selected-car-name">{this.state.vehicleType}</span>
                          <i
                            className={this.state.leftDropDownVisible ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'}
                          />
                        </div>
                      }
                    >
                      {map(manageuserReducer.vehicleTypes, (info, index) => {
                        return <MenuItem eventKey={info}>{info.name}</MenuItem>;
                      })}
                    </DropdownButton>
                  </div>
                  <div className="AddUserSelection">
                    <div className="modal-cus-Dd veh-modal-cus-Dd-mob">
                      <DropdownButton
                        bsSize="xsmall"
                        className="selectDropDown userTypeCl modal-dd-text"
                        id="dropdown-size-large"
                        onToggle={e => this.setState({ leftDropDownVisible: e })}
                        onSelect={e => {
                          this.dropdownSelectUser(e);
                        }}
                        title={
                          <div className="input-group">
                            <span className="selected-car-name">{this.state.userType}</span>
                            <i
                              className={this.state.leftDropDownVisible ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'}
                            />
                          </div>
                        }
                      >
                        <MenuItem className="eventAddUser" eventKey="Add User">Add User</MenuItem>
                        {map(manageuserReducer.userInfo, (info, index) => {
                          return <MenuItem eventKey={info}>{info.driver.name}</MenuItem>;
                        })}
                      </DropdownButton>
                    </div>
                  </div>
                </div>
                <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={16}
                    label="Save"
                    btnCallBack={() => this.onSubmit(this)}
                    customClass="btn-theme-save add-vehcile-save-btn hidden-xs"
                  />
                  <Button
                    btnType="label"
                    btnSize="sm"
                    fontSize={16}
                    label="Cancel"
                    btnCallBack={() => window.history.back()}
                    customClass="btn-theme add-vehcile-cancel-btn hidden hidden-xs"
                  />
                  <div className="row visible-xs">
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Save"
                        btnCallBack={() => this.onSubmit(this)}
                        customClass="btn-theme-save add-vehcile-save-btn"
                      />
                    </div>
                    <div className="col-xs-6 add-veh-mob">
                      <Button
                        btnType="label"
                        btnSize="sm"
                        fontSize={16}
                        label="Cancel"
                        btnCallBack={() => window.history.back()}
                        customClass="btn-theme hidden add-vehcile-cancel-btn"
                      />                  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.searchMobile &&
          <div>

            <MobileHeaderSearch
              mobile={true}
              actions={this.props.actions}
              commonReducer={this.props.commonReducer}
              mobSearchClick={() => this.setState({ searchMobile: false })}
            />
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyVehicles/addVehicle.jsx